import React from 'react'
import PropTypes from 'prop-types'
import Carousel from 'nuka-carousel'

import Icon from 'Pods/Shared/Icon/Icon'
import { CurrentBreakpoint } from 'Utils/GetBreakpoint'

class ItemsListingGallery extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      slideIndex: 0,
      maxPages: Math.ceil(props.itemsCount / 5),
      currentPage: 1,
      modelsPerRow: 5,
      modelsSpacing: 32,
      isShowingControls: true,
      heightMode: 'current',
    }

    this.updateCarousel = this.updateCarousel.bind(this)
    this.nextClicked = this.nextClicked.bind(this)
    this.prevClicked = this.prevClicked.bind(this)
  }

  componentDidMount() {
    this.updateCarousel()
    window.addEventListener('resize', this.updateCarousel)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateCarousel)
  }

  updateCarousel() {
    let models = 5
    let spacing = 32
    let controls = true

    switch (CurrentBreakpoint()) {
      case 'xs':
        models = 1.25
        spacing = 8
        controls = false
        break;
      case 'sm':
        models = 2.25
        spacing = 8
        controls = false
        break;
      case 'md':
        models = 2.25
        spacing = 20
        controls = true
        break;
      case 'lg':
        models = 3
        spacing = 24
        controls = true
        break;
      case 'xl':
        models = 3
        spacing = 24
        controls = true
        break;
      default:
        models = 5
        spacing = 24
        controls = true
    }

    this.setState({
      modelsPerRow: models,
      modelsSpacing: spacing,
      isShowingControls: controls,
      heightMode: 'max',
      maxPages: Math.ceil(this.props.itemsCount / models),
    })
  }

  nextClicked(nextSlide) {
    if (this.state.currentPage < this.state.maxPages) {
      this.setState({ currentPage: this.state.currentPage += 1 }, nextSlide())
    }
  }

  prevClicked(previousSlide) {
    this.setState({ currentPage: this.state.currentPage -= 1 }, previousSlide())
  }

  render() {
    if (this.props.skipGallery) {
      return this.props.children
    }
    return (
      <Carousel
        slideIndex={this.state.slideIndex}
        beforeSlide={(_, slideIndex) => this.setState({ slideIndex })}
        renderCenterLeftControls={({ previousSlide }) => (
          <button
            className={`btn btn-outline-default btn-white ${!this.state.slideIndex ? 'disabled' : ''}`}
            onClick={() => { this.prevClicked(previousSlide) }}
          >
            <Icon type={['fal', 'chevron-left']} notSpaced />
          </button>
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <button
            className={`btn btn-outline-default btn-white ${this.state.currentPage < this.state.maxPages ? '' : 'disabled'}`}
            onClick={() => { this.nextClicked(nextSlide) }}
          >
            <Icon type={['fal', 'chevron-right']} notSpaced />
          </button>
        )}
        slidesToShow={this.state.modelsPerRow}
        slidesToScroll={Math.floor(this.state.modelsPerRow)}
        cellSpacing={this.state.modelsSpacing}
        cellAlign="left"
        withoutControls={!this.state.isShowingControls}
        heightMode={this.state.heightMode}
      >
        {this.props.children}
      </Carousel>
    )
  }
}

ItemsListingGallery.propTypes = {
  itemsCount: PropTypes.number.isRequired,
  skipGallery: PropTypes.bool.isRequired,
}

export default ItemsListingGallery
